/**
 * masterLocalization — Static en.json import
 *
 * This explicit static import guarantees that Vite/Rollup bundles en.json
 * into the production chunk even if tree-shaking or code-splitting would
 * otherwise omit it. Never delete this file.
 *
 * Used by localizationResolver.ts to provide zero-latency English fallbacks
 * so the UI always shows readable text instead of raw i18n keys.
 */
import en from "@/i18n/en.json";

/** The complete English message catalogue (flat+nested structure as-is). */
export const masterLocalization: Record<string, unknown> = en;
